// extracted by mini-css-extract-plugin
export default {"metric-detail-table":"MetricDetailTable_metric-detail-table__gg7EF"};